import { InputNumber } from 'primeng/inputnumber';
import { Select } from 'primeng/select';
import { Listbox } from 'primeng/listbox';
import { Injectable, ElementRef } from '@angular/core';
import { Table } from 'primeng/table';
import { DatePicker } from 'primeng/datepicker';

@Injectable({
  providedIn: 'root'
})
//To resolve Accessibility axe tool issues
export class AccessibilityService {
  // ARIA attributes must conform to valid values (For multiselect box)
  public listboxAriaMultiSelectableSetTrue(listBox: Listbox) {
    if (listBox) {
      const selector = listBox.el.nativeElement
        ?.querySelector('div.p-listbox.p-component')
        ?.querySelector('div.p-listbox-list-wrapper')
        ?.querySelector('ul.p-listbox-list');
      if (selector != null) {
        selector.ariaMultiSelectable = true;
      }
    }
  }

  //Elements must only use allowed ARIA attributes
  public dropdownSetAttributes(
    dropdown: Select,
    attributeMap: Map<string, string>
  ) {
    if (dropdown) {
      const selector = dropdown.el.nativeElement
        .querySelector('div.ng-tns-c76-6.p-select.p-component')
        .querySelector('div.p-hidden-accessible.ng-tns-c76-6')
        .querySelector('input.ng-tns-c76-6');

      attributeMap.forEach((value: string, key: string) => {
        selector.setAttribute(key, value);
      });
    }
  }

  //Buttons must have discernible text
  //ARIA commands must have an accessible name
  //ARIA dialog and alertdialog nodes should have an accessible name
  //ARIA input fields must have an accessible name
  //if the button is enabled then need to remove the p-disabled class
  public tableSetTitle(table: Table, title: string) {
    if (table) {
      table.el.nativeElement
        .querySelector('div.p-datatable.p-component')
        .querySelector('p-paginator')
        .querySelector('div.p-paginator-bottom.p-paginator.p-component')
        .querySelector(
          'button.p-paginator-first.p-paginator-element.p-link.p-disabled.p-ripple'
        ).title = title;
    }
  }

  // Ensures every ARIA input  field has an accessible name - Title required for p-select-items
  // Set attributes to p-selectlist
  public setDropDownItemsAttributes(
    dropDownList: Select,
    props: Map<string, string>
  ) {
    if (dropDownList && dropDownList.el) {
      const selector =
        dropDownList.el.nativeElement.querySelector('.p-select-items');
      if (selector) {
        this.setControlAttributes(selector, props);
      }
    }
  }

  // Ensures every ARIA button, link and menu item has an accessible name
  public setAccessibleNameForDropdownMenuButton(
    dropDownList: Select,
    ariaLabelText: string
  ) {
    if (dropDownList.el) {
      const props = new Map<string, string>().set('aria-label', ariaLabelText);

      const selector =
        dropDownList.el.nativeElement.querySelector('.p-select-trigger');
      if (selector) {
        this.setControlAttributes(selector, props);
      }
    }
  }

  // Ensures every ARIA button, link and menu item has an accessible name
  public setAccessibleNameForGridPaginationMenu(
    tableElement: Table,
    ariaLabelText: string
  ) {
    const props = new Map().set('aria-label', ariaLabelText);
    const selector = tableElement.el?.nativeElement
      ?.querySelector('div.p-paginator-rpp-options.p-select.p-component')
      ?.querySelector('.p-select-trigger');

    if (selector) {
      this.setControlAttributes(selector, props);
    }
  }

  //Ensures every form element  has a label
  public setDropDownLabelAttributes(
    dropDownList: Select,
    props: Map<string, string>
  ) {
    if (dropDownList) {
      const selector = dropDownList.el.nativeElement.querySelector(
        '.p-hidden-accessible input'
      );
      if (selector) {
        this.setControlAttributes(selector, props);
      }
    }
  }

  // Ensures every ARIA input  field has an accessible name - Title required for p-listbox-list
  // Set the attributes to p-listbox
  public setListBoxListAttributes(
    listbox: Listbox,
    props: Map<string, string>
  ) {
    const selector = listbox.el.nativeElement.querySelector('.p-listbox-list');
    this.setControlAttributes(selector, props);
  }

  // Ensures every form element  has a label
  // Set the attributes to p-listbox
  public setListBoxLabelAttributes(
    listbox: Listbox,
    attributeMap: Map<string, string>
  ) {
    const selector = listbox.el.nativeElement.querySelector(
      '.p-hidden-accessible input'
    );
    this.setControlAttributes(selector, attributeMap);
  }

  // Ensures every form element  has a label for paginator Dropdown school page
  public setListBoxSchoolTableAttributes(
    table: Table,
    attributeMap: Map<string, string>
  ) {
    const selector = table?.el?.nativeElement
      ?.querySelector('div.p-paginator-bottom.p-paginator.p-component')
      ?.querySelector('.p-hidden-accessible input');

    if (selector) {
      this.setControlAttributes(selector, attributeMap);
    }
  }

  // ARIA input fields must have an accessible name on pagination dropdown
  public setTitleForGridPaginationDropdown(selector: any, title: string) {
    if (selector) {
      try {
        selector = selector.querySelector('.p-select-items').title = title;
      } catch (error) {
        console.error(error);
      }
    }
  }

  // Ensures every form element  has a label for paginator Dropdown exclusion pupil, exclusion list pages,
  // schools Menu-Access to portal Dropdown
  public setListBoxTableAttributes(
    table: Table,
    attributeMap: Map<string, string>
  ) {
    const selector = table.el.nativeElement.querySelector(
      '.p-hidden-accessible input'
    );
    this.setControlAttributes(selector, attributeMap);
  }

  // Set the attributes to the element
  public setControlAttributes(control: Element, props: Map<string, string>) {
    if (control) {
      props.forEach((attr, val) => {
        if (!control.hasAttribute(attr)) {
          control.setAttribute(val, attr);
        }
      });
    }
  }

  // Buttons must have discernible text (For Split Button Menu)
  public splitButtonSetTitle(table: Table, title: string) {
    if (table) {
      try {
        const attribute = new Map().set('title', title);
        const selector =
          table.el.nativeElement.querySelectorAll('table > tbody > tr');
        const querySelector =
          '.p-splitbutton-menubutton.p-button.p-component.p-button-icon-only';

        selector.forEach((element) => {
          this.setControlAttributes(
            element.querySelector(querySelector),
            attribute
          );
        });
      } catch (error) {
        console.error(error);
      }
    }
  }

  // Split button menu must have discernible text
  public splitButtonSetTitleMeetings(element: any, title: string) {
    if (element) {
      try {
        const selector = element.nativeElement.querySelectorAll(
          '.p-col-12.p-md-6.p-lg-6.meeting-cards-mergin.ng-star-inserted'
        );

        selector.forEach((element) => {
          element
            .querySelector('.meetingCard')
            .querySelector('.p-button-custom.float-right.meeting-status-font')
            .querySelector(
              'button.p-splitbutton-menubutton.p-button.p-component.p-button-icon-only'
            )
            .setAttribute('title', title);
        });
      } catch (error) {
        console.error(error);
      }
    }
  }

  // Set discernible text for menttings section add/edit meeting pop-up
  public setDescirnibleTextPopUpAddEdit(
    dialog: any,
    isGovtMeeting: boolean,
    isReinstateFieldsVisible: boolean
  ) {
    if (dialog) {
      try {
        const selector = dialog.el.nativeElement;

        // Close icon button
        selector
          .querySelector('div.mydialog.p-dialog')
          .querySelector('.popupHeaderCloseButton.ng-star-inserted')
          .querySelector('button').title = 'Close Pop Up';

        // Meeting Date and Time Calendar Button
        const baseSelectorForDateTimeButtons = selector
          .querySelector('div.p-dialog-content')
          .querySelector('form');

        if (isGovtMeeting) {
          baseSelectorForDateTimeButtons
            .querySelector('div#divMeetingDateAndTime')
            .querySelector('button').title =
            'Choose government meeting date and time';
        } else {
          baseSelectorForDateTimeButtons
            .querySelector('div#divRequestedMeetingDateTime')
            .querySelector('button').title =
            'Choose meeting requested date and time';

          baseSelectorForDateTimeButtons
            .querySelector('div#divAppealMeetingDateTime')
            .querySelector('button').title =
            'Choose appeal meeting requested date and time';
        }

        if (isReinstateFieldsVisible) {
          baseSelectorForDateTimeButtons
            .querySelector('div#divReinstatementDate')
            .querySelector('button').title =
            'Choose reinstatement date and time';
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  // Buttons must have discernible text (For gird navigation button titles)
  public setTablePaginationControlsTitle(table: Table, title: string) {
    if (table) {
      try {
        const attributeMap = new Map();
        attributeMap.set(
          'button.p-paginator-first.p-paginator-element.p-link.p-disabled.p-ripple',
          'First'
        );
        attributeMap.set(
          'button.p-paginator-prev.p-paginator-element.p-link.p-disabled.p-ripple',
          'Previous'
        );
        attributeMap.set(
          'button.p-paginator-next.p-paginator-element.p-link.p-disabled.p-ripple',
          'Next'
        );
        attributeMap.set(
          'button.p-paginator-last.p-paginator-element.p-link.p-disabled.p-ripple',
          'Last'
        );

        const selector = table.el.nativeElement
          ?.querySelector('div.p-datatable.p-component')
          ?.querySelector('p-paginator')
          ?.querySelector('div.p-paginator-bottom.p-paginator.p-component');
        attributeMap.forEach((value: string, key: string) => {
          if (selector) selector.querySelector(key).title = value;
        });
        this.setTitleForGridPaginationDropdown(selector, title);
      } catch (error) {
        console.error(error);
      }
    }
  }

  // Buttons must have discernible text - Title required for p-datepicker-trigger
  public setCalenderButtonAttributes(
    cal: DatePicker,
    props: Map<string, string>
  ) {
    const selector = cal.el.nativeElement.querySelector(
      '.p-datepicker-trigger'
    );
    if (selector) {
      this.setControlAttributes(selector, props);
    }

    this.calenderDefaultAttributes(cal);
  }

  public setefaultAttributesForIndependentCalendar(elementRef: ElementRef) {
    // Set the previous button text
    let selector =
      elementRef.nativeElement.offsetParent.querySelector('.p-datepicker-prev');
    if (selector) {
      selector.title = 'Previous';
    }

    // Set the next button text
    selector =
      elementRef.nativeElement.offsetParent.querySelector('.p-datepicker-next');
    if (selector) {
      selector.title = 'Next';
    }

    // Set the hour button button text
    selector =
      elementRef.nativeElement.offsetParent.querySelector('.p-hour-picker');
    if (selector) {
      const hourButtons = selector.querySelectorAll('button.p-ripple');
      hourButtons[0].title = 'Up';
      hourButtons[1].title = 'Down';
    }

    // Set the minute button button text
    selector =
      elementRef.nativeElement.offsetParent.querySelector('.p-minute-picker');
    if (selector) {
      const hourButtons = selector.querySelectorAll('button.p-ripple');
      hourButtons[0].title = 'Up';
      hourButtons[1].title = 'Down';
    }
  }

  private calenderDefaultAttributes(cal: DatePicker) {
    // Set the previous button text
    let selector = cal.el.nativeElement.querySelector('.p-datepicker-prev');
    if (selector) {
      const previousButtonProps = new Map<string, string>();
      previousButtonProps.set('title', 'Previous');
      this.setControlAttributes(selector, previousButtonProps);
    }

    // Set the next button text
    selector = cal.el.nativeElement.querySelector('.p-datepicker-next');
    if (selector) {
      const nextButtonProps = new Map<string, string>();
      nextButtonProps.set('title', 'Next');
      this.setControlAttributes(selector, nextButtonProps);
    }
    return selector;
  }

  // Buttons must have discernible text - Title required for p-inputnumber-button-down and p-inputnumber-button-up
  public setInputNumberAttributes(
    input: InputNumber,
    props: Map<string, string>
  ) {
    const buttonUpSelector = input.el.nativeElement.querySelector(
      '.p-inputnumber-button-up'
    );
    if (buttonUpSelector) {
      this.setControlAttributes(buttonUpSelector, props);
    }
    const buttonDownSelector = input.el.nativeElement.querySelector(
      '.p-inputnumber-button-down'
    );
    if (buttonDownSelector) {
      this.setControlAttributes(buttonDownSelector, props);
    }
  }

  // Remove control attributes
  public removeControlAttributes(control: any, props: Map<string, string[]>) {
    if (control && control.el) {
      props.forEach((attrs: string[], key: string) => {
        const selector = control.el.nativeElement.querySelector(key);
        if (selector) {
          attrs.forEach((attr) => {
            this.removeAttributes(selector, attr);
          });
        }
      });
    }
  }

  // Remove attributes for control
  private removeAttributes(selector, attributes) {
    if (selector.hasAttribute(attributes)) {
      selector.removeAttribute(attributes);
    }
  }

  // Remove aria-expanded attribute
  public removeAriaExpandedAttribute(control: any) {
    const attrs: string[] = ['aria-expanded'];
    const props = new Map<string, string[]>();
    props.set("input[type='text']", attrs);
    this.removeControlAttributes(control, props);
  }

  //ARIA dialog and alertdialog nodes should have an accessible name
  public setDialogBoxAriaAttributes(dialog: any, ariaTitle: string) {
    try {
      const selector = dialog.el.nativeElement.querySelector(
        'div.mydialog.p-dialog.p-component.p-dialog-resizable.ng-star-inserted'
      );
      if (selector) {
        const attributeMapping = new Map().set('title', ariaTitle);
        this.setControlAttributes(selector, attributeMapping);
      }
    } catch (err) {
      console.error(err);
    }
  }

  //ARIA dialog and alertdialog nodes should have an accessible name
  public setDynamicDialogBoxAriaAttributes(element: any, ariaTitle: string) {
    try {
      const selector =
        element?.el?.nativeElement?.parentElement?.parentElement?.parentElement;
      if (selector) {
        const attributeMapping = new Map().set('title', ariaTitle);
        this.setControlAttributes(selector, attributeMapping);

        // Ensures buttons have discernible text (For close icon button)
        const buttonSelector = selector.querySelector(
          'button.p-dialog-header-icon.p-dialog-header-maximize'
        );
        if (buttonSelector) {
          const buttonAttributeMapping = new Map().set('title', 'Close');
          this.setControlAttributes(buttonSelector, buttonAttributeMapping);
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  // Buttons must have discernible text - for toaster messages
  public setAttributesForAlertBox(alertElementRef: ElementRef) {
    // There can be multiple toaster messages, so select all
    const selector =
      alertElementRef.nativeElement.offsetParent.querySelectorAll(
        '.p-toast-message'
      );
    if (selector) {
      const titleText = 'Close';
      const attributeMapping = new Map().set('title', titleText);
      selector.forEach((element) => {
        const innerSelector = element.querySelector(
          'button.p-toast-icon-close'
        );
        this.setControlAttributes(innerSelector, attributeMapping);
      });
    }
  }

  // Ensures all ARIA attributes have valid values
  // Invalid ARIA attribute value: aria-activedescendant
  public setDropDownAriaActiveDescendant(dropdown: Select, value: string) {
    try {
      if (dropdown) {
        const selector = dropdown.el.nativeElement?.querySelector(
          '.p-hidden-accessible input'
        );
        if (selector) selector.setAttribute('aria-activedescendant', value);
      }
    } catch (err) {
      console.error(err);
    }
  }

  // Ensures all ARIA attributes have valid values
  // Invalid ARIA attribute value: aria-labelledby
  public setDialogAriaLabelledBy(dialog: any, value: string) {
    try {
      const selector = dialog.el.nativeElement.querySelector(
        'div.mydialog.p-dialog.p-component.p-dialog-resizable.ng-star-inserted'
      );
      if (selector) {
        selector.setAttribute('aria-labelledby', value);
      }
    } catch (err) {
      console.error(err);
    }
  }

  // Set focus on the current table row
  public setFocusOnSelectedTableRow(allSchoolList: Table, rowIndex: number) {
    if (allSchoolList) {
      setTimeout(() => {
        allSchoolList.el.nativeElement
          .querySelector('tbody')
          .querySelectorAll('tr')
          [rowIndex].focus();
      }, 0);
    }
  }

  // On press enter key, call the edit method
  public editRowData(allSchoolList: Table, rowIndex: number) {
    if (allSchoolList) {
      allSchoolList.el.nativeElement
        .querySelector('tbody')
        .querySelectorAll('tr')
        [rowIndex].querySelector('button')
        .click();
    }
  }

  //Ensures all page content is contained by landmarks
  public setLandmarkRoleForDropDown(dropDownList: Select) {
    if (dropDownList.el) {
      const props = new Map<string, string>().set('role', 'region');

      const selector = dropDownList.el.nativeElement.querySelector(
        '.ng-trigger-overlayAnimation'
      );
      if (selector) {
        this.setControlAttributes(selector, props);
      }
    }
  }

  // Ensure elements that have scrollable content are accessible by keyboard
  public setTabindexInScrollableRegionForDropdDown(dropDownList: Select) {
    try {
      if (dropDownList.el) {
        const selector = dropDownList.el.nativeElement.querySelector(
          '.p-select-items-wrapper'
        );
        if (selector) {
          const attributeMapping = new Map().set('tabindex', '0');
          this.setControlAttributes(selector, attributeMapping);
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  //Ensure elements that have scrollable content are accessible by keyboard - dynamic dialogbox
  public setTabindexInScrollableRegionForDialogBox(element: any) {
    try {
      const selector =
        element?.el?.nativeElement?.parentElement?.parentElement?.parentElement.querySelector(
          '.p-dialog-content'
        );
      if (selector) {
        const attributeMapping = new Map().set('tabindex', '0');
        this.setControlAttributes(selector, attributeMapping);
      }
    } catch (err) {
      console.error(err);
    }
  }

  //Ensures role attribute has an appropriate value for the element
  public removeRoleAttributeForDropDown(control: any) {
    const attrs: string[] = ['role'];
    const attributeMapping = new Map().set("input[type='text']", attrs);
    this.removeControlAttributes(control, attributeMapping);
  }

  //Ensures role attribute has an appropriate value for the element -paginator dropdown
  public removeRoleAttributeForPaginatorDropDown(control: any) {
    const attrs: string[] = ['role'];
    const attributeMapping = new Map().set(
      "p-paginator input[type='text']",
      attrs
    );
    this.removeControlAttributes(control, attributeMapping);
  }

  // Remove aria-expanded attribute-paginator dropdown
  public removeAriaExpandedAttributeForPaginator(control: any) {
    const attrs: string[] = ['aria-expanded'];
    const props = new Map<string, string[]>();
    props.set("p-paginator input[type='text']", attrs);
    this.removeControlAttributes(control, props);
  }

  // Set focus on the current table row
  public setFocusOnSelectedPagingTableRow(
    allSchoolList: Table,
    rowIndex: number
  ) {
    if (allSchoolList) {
      // Get row index for the table for current page of pagination table
      const focusRowIndex = this.getRowIndexForPaginationTable(
        allSchoolList,
        rowIndex
      );

      setTimeout(() => {
        allSchoolList.el?.nativeElement
          ?.querySelector('tbody')
          ?.querySelectorAll('tr')
          [focusRowIndex]?.focus();
      }, 0);
    }
  }

  // On press enter key, call the edit method
  public editRowDataForPagingTable(allSchoolList: Table, rowIndex: number) {
    // Get row index for the table for current page of pagination table
    const focusRowIndex = this.getRowIndexForPaginationTable(
      allSchoolList,
      rowIndex
    );

    if (allSchoolList) {
      allSchoolList.el?.nativeElement
        ?.querySelector('tbody')
        ?.querySelectorAll('tr')
        [focusRowIndex]?.querySelector('button')
        ?.click();
    }
  }

  // Generic method to get the rowindex to focus on row or edit the row on enter
  // For all prime-ng pagination tables
  private getRowIndexForPaginationTable(
    allSchoolList: Table,
    rowIndex: number
  ) {
    // Get selected page size to show on a single page of data table
    let pageSize = allSchoolList.el?.nativeElement
      ?.querySelector('p-paginator')
      ?.querySelector('p-select')
      ?.querySelector('.p-select-label.p-inputtext')?.textContent;
    pageSize = pageSize !== null ? parseInt(pageSize) : 0;

    // Get the current page number
    let selectedPage = allSchoolList.el?.nativeElement
      ?.querySelector('p-paginator')
      ?.querySelector('span.p-paginator-pages')
      ?.querySelector('button.p-highlight')?.textContent;
    selectedPage = selectedPage !== null ? parseInt(selectedPage) : 0;

    // Focus nned to sent on the row
    // 1. If row index is greater than page size then ->
    //    a. Subtract the number of pages X page size to get the number between range 0 to page number
    return rowIndex > pageSize
      ? rowIndex - (selectedPage - 1) * pageSize
      : rowIndex;
  }

  // Generic method to scroll the page to bottom
  public onTablePageSizeChange() {
    try {
      setTimeout(() => {
        window.scrollTo(
          0,
          document?.body?.scrollHeight ||
            document?.documentElement?.scrollHeight
        );
      }, 0);
    } catch (e) {
      console.error(e);
    }
  }

  // Remove aria expandaed attribute from split button
  // Parameters:
  // table: Table element
  public removeAriaExpandedAttributeForSplitButtons(table: Table) {
    try {
      const tableSelector =
        table.el.nativeElement.querySelectorAll('table > tbody > tr');

      this.removeAriaExpandedAttributeSplitButtonCommon(tableSelector);
    } catch (error) {
      console.error(error);
    }
  }

  // Remove aria expandaed attribute from split button
  // Parameters:
  // element: Element ref object
  public removeAriaExpandedAttributeForMeetingsSplitButtons(
    element: ElementRef
  ) {
    try {
      const tableSelector = element.nativeElement.querySelectorAll(
        '.confirmation-button-container'
      );

      this.removeAriaExpandedAttributeSplitButtonCommon(tableSelector);
    } catch (error) {
      console.error(error);
    }
  }

  // Common method to remove aria expanded attribute for split buttons
  // Parameters:
  // tableSelector: List of elements which contains split button
  private removeAriaExpandedAttributeSplitButtonCommon(
    tableSelector: any
  ): void {
    const attribute: string[] = ['aria-expanded'];
    const querySelector = '.p-ripple.p-element.p-menubar-link';

    if (tableSelector) {
      tableSelector?.forEach((element) => {
        const controlSelector = element.querySelectorAll(querySelector);
        if (controlSelector) {
          controlSelector.forEach((control) => {
            this.removeAttributes(control, attribute);
          });
        }
      });
    }
  }
}
